import React, { useCallback } from 'react';
import { updateUnitData } from '@starflow/app/helpers/flow';
import { config } from '@shakkerai/config';

import outlinedCrown from '../../../../modules/models/assets/crown_outlined.png';
import { isOverseas } from '@shakkerai/pro-utils';
const isMainland = config.env === 'aliyun';

const countOptions = isMainland ? [1, 2, 3, 4, 8] : [1, 2, 3, 4, 8];

const normalUnselectStyle = 'bg-[#f4f6f8] text-[#2d2d2d]';
const normalSelectedStyle = 'disabled:bg-primary/10 disabled:border-primary';

const vipUnselectStyle = 'bg-[#FFBC0026] text-[#D58B1C]';
const vipSelectedStyle = 'disabled:text-[#D58B1C] disabled:bg-[#FFBC0026] disabled:border-[#FFBC00]';

export const vipOptions = !isMainland ? [1, 2, 3, 8] : [8];

export const GenerateCount = React.memo(({ generator }) => {
  const styles = useCallback(
    (count) => {
      if (generator.data.count === count) {
        if (vipOptions.includes(count)) {
          return {
            style: vipSelectedStyle,
            selected: true,
            isVip: true,
          };
        } else {
          return {
            style: normalSelectedStyle,
            selected: true,
            isVip: false,
          };
        }
      } else {
        if (vipOptions.includes(count)) {
          return {
            style: vipUnselectStyle,
            selected: false,
            isVip: true,
          };
        } else {
          return {
            style: normalUnselectStyle,
            selected: false,
            isVip: false,
          };
        }
      }
    },
    [generator],
  );

  return (
    <div className="flex items-center justify-between mt-3 space-x-1.5">
      {countOptions.map((count, index) => (
        <button
          key={index}
          onClick={() => updateUnitData(generator.id, { count })}
          disabled={generator.data.count === count}
          className={`flex-1 h-6 pt-0.5 border border-transparent rounded-sm text-xs relative ${styles(count).style}`}
        >
          {count}
          {isOverseas && styles(count).selected && styles(count).isVip && (
            <img src={outlinedCrown} className="w-3 absolute -right-[2px] -top-[8px]" alt="" />
          )}
        </button>
      ))}
    </div>
  );
});
